import React from 'react';
import PrintableFullReport from '../../components/printableFullReport';
import moment from 'moment';
import {formatCurrency, formatStaticCurrency} from 'helpers/currencyHelper.jsx';

import ReportApi from 'api/report.jsx';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {dateTimeFormats} from 'helpers/constants';

import events from 'lib/events';

class AnalysesByEmployeeSummary extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {};

  printReport(data) {
    const {filters, tableData, POSActive} = this.props;
    let {formatMessage} = this.props.intl;
    const columns = [
        {name: formatMessage({id: 'general.total.employees'}), key: 'TotalEmployees'},
        {name: formatMessage({id: 'general.total.analyses'}), key: 'TotalAnalyses'},
        {name: formatMessage({id: 'reports.average.analyses.employee'}), key: 'AvgAnalysesPerEmployee'},
    ];
    let posColumns = [
        {name: formatMessage({id: 'general.total.sales'}), key: 'TotalSales'},
    ];

    data.TotalSales = formatStaticCurrency(data.TotalSales);

    const tableColumns = [
      {name: formatMessage({id: 'general.employee.name'}), key: 'Name'},
      {name: formatMessage({id: 'general.store'}), key: 'Store'},
      {name: formatMessage({id: 'general.analyses'}), key: 'AnalysesCount'},
      {name: formatMessage({id: 'general.analyses.problems'}), key: 'AnalysesWithProblemsCount'},
    ];

    if (POSActive) {
      columns.push(...posColumns);
    }

    return <PrintableFullReport
      end={moment(filters.dateFrom).format(dateTimeFormats.numeralDate)}
      endLabel={formatMessage({id: 'general.end.date'})}
      formatMessage={formatMessage}
      start={moment(filters.dateTo).format(dateTimeFormats.numeralDate)}
      startLabel={formatMessage({id: 'general.start.date'})}
      summaryColumns={columns}
      summaryData={data}
      tableColumns={tableColumns}
      tableData={data.Employees}
      title={formatMessage({id: 'general.analyses.employee'})}
    />;
  };

  export = () => {
    let filters = this.props.filters;

    ReportApi.getWaterAnalysesByEmployeeExport(
      this.props.intl.locale,
      filters.dateFrom,
      filters.dateTo,
      filters.branch,
    );
  };

  render() {

    let carts;
    let tableRows;
    let tableTitle;
    let data = this.props.data;
    let {formatMessage} = this.props.intl;

    if(data && Object.keys(data).length) {
      let summary = [
				{title: formatMessage({id: 'general.total.employees'}), value: data.TotalEmployees},
				{title: formatMessage({id: 'general.total.analyses'}), value: data.TotalAnalyses},
				{title: formatMessage({id: 'reports.average.analyses.employee'}), value: data.AvgAnalysesPerEmployee},
				{title: formatMessage({id: 'reports.analyses.active.customers'}), value: data.TotalActiveAnalyses},
        {title: formatMessage({id: 'reports.analyses.inactive.customers'}), value: data.TotalInactiveAnalyses},
      ];

      if(this.props.POSActive) {
        summary.push({title: formatMessage({id: 'general.total.sales'}), value: formatCurrency(data.TotalSales)});
      }

      carts = summary.map((cart, i) =>
        <div className={'col-sm-4 ' + (cart.class ? cart.class : '')} key={i} >
          {cart.title} <br />
          <span>{cart.value}</span>
        </div>
			);

      tableRows = data.Employees.map((row, i) =>
        <tr key={i} className={i % 2 !== 0 ? 'gray-row' : ''}>
          <td>{row.Name}</td>
          <td>{row.Store}</td>
          <td className="table-number">{row.AnalysesCount}</td>
          <td className="table-number">{row.AnalysesWithProblemsCount}</td>
        </tr>
			);

    }

    return <div>
      <div className="summary-container">
        <h2><FormattedMessage id="reports.report.summary"/></h2>
        <span className={data && Object.keys(data).length ?
          'summary-date' :
          'not-show'}> | <FormattedMessage id="general.date.range.labelled"
                                           values={{
                                             start: moment(this.props.filters.dateFrom)
                                               .format(dateTimeFormats.numeralDate),
                                             end: moment(this.props.filters.dateTo)
                                               .format(dateTimeFormats.numeralDate),
                                           }}/>
        </span>
        <br/>
        <span><FormattedMessage id="reports.reveal.report.summary"/></span>
        {this.props.showNoDataMessage ?
          <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
        <div className="container-fluid custom-container-margins">
          <div className={carts && Object.keys(carts).length ? 'row' : 'not-show'}
               id="row-no-padding">
            {carts}
          </div>
          <div className={data && Object.keys(data).length ? 'row' : 'not-show'}
               id="row-no-padding">
            <table className="summary-table">
              <tbody>
                <tr className="table-title">
                  <th className="bigger-row"><FormattedMessage id="general.employee.name"/></th>
                  <th><FormattedMessage id="general.store"/></th>
                  <th className="column-custom-width table-number"><FormattedMessage id="general.analyses"/></th>
                  <th className="column-custom-width table-number"><FormattedMessage id="general.analyses.problems"/></th>
                </tr>
                {tableRows}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='col-sm-12 button-group'>
        <button className='btn btn-default pull-right'
                disabled={data && Object.keys(data).length <= 0}
                onClick={() => {
                  events.publish('print', this.printReport(this.props.data));
                }}><FormattedMessage id="reports.print.summary"/></button>
        <button className='btn btn-primary pull-right'
                onClick={this.export}><FormattedMessage id="reports.export.report"/></button>
      </div>
    </div>;
  }
}

export default injectIntl(AnalysesByEmployeeSummary);
